import {
	BlurryRejectThreshold,
	ClusterThreshold,
	FaceRejectThreshold,
	ProjectCullingSettings,
} from "@/lib/catalog/types"

export const getBlurrySensitivity = (threshold: BlurryRejectThreshold) => {
	switch (threshold) {
		case BlurryRejectThreshold.Lenient:
			return "lenient"
		case BlurryRejectThreshold.Strict:
			return "strict"
		default:
			return "balanced"
	}
}

export const getFaceSensitivity = (threshold: FaceRejectThreshold) => {
	switch (threshold) {
		case FaceRejectThreshold.Lenient:
			return "lenient"
		case FaceRejectThreshold.Strict:
			return "strict"
		default:
			return "balanced"
	}
}

export const getGroupSimilarSensitivity = (threshold: ClusterThreshold) => {
	switch (threshold) {
		case ClusterThreshold.Loose:
			return "loose"
		case ClusterThreshold.Exact:
			return "exact"
		default:
			return "similar"
	}
}

export const getCullingSettingsEventProperties = (options: {
	cullingSettings: ProjectCullingSettings
	suggestKeepersCount: number
	totalCount?: number
	includeAutoAdvance?: boolean
}) => {
	const { cullingSettings, suggestKeepersCount, totalCount, includeAutoAdvance } = options

	return {
		groupSimilarEnabled: cullingSettings.groupSimilarPhotos,
		groupSimilarSensitivity: getGroupSimilarSensitivity(cullingSettings.groupSimilarThreshold),
		rejectBlurryEnabled: cullingSettings.rejectBlurryPhotos,
		rejectBlurrySensitivity: getBlurrySensitivity(cullingSettings.blurryPhotoThreshold),
		rejectFaceEnabled: cullingSettings.rejectPoorFaceQuality,
		rejectFaceSensitivity: getFaceSensitivity(cullingSettings.poorFaceQualityThreshold),
		rejectExposureEnabled: cullingSettings.rejectPoorExposure,
		suggestKeepersEnabled: cullingSettings.suggestKeepers,
		suggestKeepersCount,
		...(totalCount != null ? { totalCount } : {}),
		...(includeAutoAdvance
			? { autoAdvanceEnabled: cullingSettings.autoAdvanceAfterTagging }
			: {}),
	}
}
